<app-modal-base
	[headerTitle]="getI18nString(true, 'title' )"
	[modalMainStyleClasses]="'px-0 px-md-5 pt-0'"
	[modalSubheaderStyleClasses]="'px-0 px-md-5 pb-0'"
	[modalIdentifier]="modalIdentifier"
	[renderModalAside]="false"
	[renderModalSubheader]="false"
	[renderModalPreFooter]="false"
	[renderModalHeaderCloseButton]="false"
>

	<!-- MAIN -->
	<ng-container class="main-content">

		<!-- Title, Descriptions, Timer -->
		<div class="row mx-auto flex-column justify-content-center align-items-center text-center h-100 fade show showInvalidTenantModalWrapper maxWidth-limit">

			<!-- Title, Descriptions -->
			<div class="flex-row description">

				<!-- Title -->
				<div class="subtitle pb-2 text-uppercase fw-bold">
					{{ getI18nString( true, 'attention' ) }}
				</div>

				<!-- Descriptions -->
				<p class="fw-regular">{{ getI18nString( true, 'description' ) }}</p>
				<p class="mt-3 fw-regular">{{ getI18nString( true, 'supportDescription' ) }}</p>
			</div>

			<!-- Timer -->
			<div class="timer">
				<i *ngFor="let dot of dots" class="dot" [ngClass]="{'fadeOut': dot?.fadeOut}"></i>
			</div>
		</div>
	</ng-container>
</app-modal-base>
